/** Qualité de l'image en Kb */
export enum EDmsImageQuality {
	low = 5,
	medium = 25,
	high = 50,
	natural = null
}